import moment from 'moment'
import {
  scheduleTypeDef,
  severityTypeDef,
  typeTestDef,
} from 'vdg-patients/appointment/diagnosis/test-examination/VdgTestModal'
import { patientFileReason } from './PatientFile'
import PatientsDiagnosisDiscussions from './PatientsDiagnosisDiscussions'

export enum OrderSource {
  manual = 'manual',
  discussion = 'discussion',
  actionReport = 'actionReport',
  hospitalizationPlan = 'hospitalizationPlan',
}

export default interface InternalExaminationPlan {
  _id?: string
  patientId: string
  scheduleType: scheduleTypeDef
  patientDiagnoses: any[]
  typeTest: typeTestDef
  test: any
  prescribedBy: any
  bloodTypes?: any
  withIn?: number | 'ASAP'
  reason?: patientFileReason
  timesADay?: number
  everyXHours?: number
  endPlanDate?: string
  severity?: severityTypeDef
  isClosed?: boolean
  closedBy?: string
  closedAt?: string
  closeDiscussion?: string
  createdAt?: string
  additionalRequests?: string
  /**
   * Protocol context (e.g. which hospitalization day an order belongs to).
   *
   * Deliberately separate from `additionalRequests`: the med-tech app renders that field verbatim
   * and, when it is present, makes the order card expand instead of starting the exam. The
   * med-tech performs these tests as usual, so only genuine test instructions belong there.
   */
  hospitalizationNote?: string
  orderSource?: OrderSource
}

export const isFollowUpBetweenSchedulePlan = (
  schedulePlans: InternalExaminationPlan[],
  dis: PatientsDiagnosisDiscussions,
) => {
  return schedulePlans.find(
    sp =>
      sp.scheduleType !== scheduleTypeDef.continuous &&
      moment(dis.createdAt).isBetween(
        moment(sp.createdAt),
        moment(sp.endPlanDate),
        undefined,
        '[]',
      ),
  )
}
